import { useEffect, useRef } from "react";

const BED_LEVEL = 0.22;

// Two looping ambient beds (adversity → change) whose balance follows the visual dissolve.
export const useSceneBeds = (srcA, srcB, mix, enabled) => {
  const a = useRef(null);
  const b = useRef(null);

  const ensure = () => {
    if (a.current) return;
    a.current = new Audio(srcA);
    b.current = new Audio(srcB);
    [a.current, b.current].forEach((el) => { el.loop = true; el.preload = "auto"; });
  };

  useEffect(() => {
    const level = enabled ? BED_LEVEL : 0;
    if (a.current) a.current.volume = level * (1 - mix);
    if (b.current) b.current.volume = level * mix;
  }, [mix, enabled]);

  const stop = () => {
    [a, b].forEach((r) => { if (r.current) { r.current.pause(); r.current.src = ""; r.current = null; } });
  };

  useEffect(() => () => {
    [a, b].forEach((r) => { if (r.current) { r.current.pause(); r.current.src = ""; r.current = null; } });
  }, [srcA, srcB]);

  return {
    startBeds: () => {
      ensure();
      const level = enabled ? BED_LEVEL : 0;
      a.current.volume = level * (1 - mix);
      b.current.volume = level * mix;
      [a.current, b.current].forEach((el) => el.play().catch(() => {}));
    },
    pauseBeds: () => [a, b].forEach((r) => r.current && r.current.pause()),
    stopBeds: stop,
  };
};
